export default __webpack_public_path__ + "assets/18300a464291db7a946a00716dda9fc8.png";